import { BaseSnapshotModel } from "../BaseSnapshotModel";

export class DoNotDisturbHoursSnapshotModel extends BaseSnapshotModel {
  constructor() {
    super();
    this.Model = {
      modelFields: [
        "do_not_disturb_hours_support",
        "do_not_disturb_hours_start_time",
        "do_not_disturb_hours_end_time"
      ],

      requiredFields: []
    };
  }
}
